export const GET_GMINDERS = 'GET_GMINDERS';
export const GET_GMINDER_DETAILS = 'GET_GMINDER_DETAILS';
export const GET_GMINDER_HISTORY = 'GET_GMINDER_HISTORY';
export const UPDATE_GMINDER = 'UPDATE_GMINDER';
